export enum Mood {
    Good = "good",
    Bad = "bad",
    None = "",
}